import { render, staticRenderFns } from "./CreateOffer.vue?vue&type=template&id=04c694b2&scoped=true&"
import script from "./CreateOffer.vue?vue&type=script&lang=js&"
export * from "./CreateOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c694b2",
  null
  
)

export default component.exports